import React from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import { PhonePausedRounded } from '@material-ui/icons';
export default function VMDeferButton({ row, deferACall, disabled }) {
  const [open, setOpen] = React.useState(false);
  const [value, setValue] = React.useState('');

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const send = () => {
    deferACall(row, value);
    setOpen(false);
    setValue('');
  };

  return (
    <>
      <IconButton onClick={handleClickOpen} disabled={disabled}>
        <PhonePausedRounded style={{ color: disabled ? 'inherit' : 'orange' }} />
      </IconButton>
      {/* <Button variant="outlined" color="primary" onClick={handleClickOpen}>
        Open form dialog
      </Button> */}
      <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
        <DialogTitle style={{ minWidth: '600px' }} id="form-dialog-title">
          Defer this call
        </DialogTitle>
        <DialogContent>
          {/* <DialogContentText>
            Please put notes here to communitcate with the nurse who's beside the TeleKart.
            This call will not be transferred to other providers.
          </DialogContentText> */}
          <TextField
            autoFocus
            margin="dense"
            id="defer-note"
            label="Message"
            type="text"
            fullWidth
            value={value}
            onChange={(event) => {
              setValue(event.target.value);
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button onClick={send} color="primary">
            Send
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
